import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/dueno-1-turno.webp")